<template>
    <div>
        <rkm-area
            v-if="model"
            title="Atendimento"
            type="fieldset"
            no-margin-top
        >
            <rkm-row>
                <rkm-col cols="6">

                    <rkm-form-input-autocomplete
                        :repository="repositories.paciente"
                        :search-fields="fields.paciente"
                        :request-query-string-params="{ not_cidadao_obito: true}"
                        :text-field="(item) => `${item.cidadao.nome}${item.prontuario ?  ' - ' + item.prontuario: ''}`"
                        label="Paciente"
                        v-model="model.paciente"
                        :validations="validations.paciente"
                        :disabled="this.model.id ? true : false"
                        uppercase
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-input
                        label="Nome social"
                        v-model="model.nomeSocial"
                        disabled
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        label="Prontuário"
                        v-model="model.prontuario"
                        disabled
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        label="CNS"
                        v-model="model.cns"
                        disabled
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        label="CPF"
                        v-model="model.cpf"
                        disabled
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-date-picker
                        label="Data de nascimento"
                        v-model="model.dataNascimento"
                        disabled
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        label="Local de atendimento"
                        :options="data.form.localAtendimento"
                        show-default-option
                        text-field="descricao"
                        v-model="model.localAtendimentoId"
                        default-option-text="Selecione"
                        value-field="id"
                        class="pt-0"
                        :validations="validations.localAtendimento"
                        :disabled="!model.paciente"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-select
                        label="Turno"
                        :options="data.form.turnos"
                        show-default-option
                        text-field="nome"
                        v-model="model.turnoId"
                        default-option-text="Selecione"
                        value-field="id"
                        class="pt-0"
                        :validations="validations.turno"
                        :disabled="!model.localAtendimentoId"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-checkbox
                        class="mx-2"
                        :label="false"
                        v-model="model.escutaInicial"
                        @change="handleEscutaInicial"
                        :disabled="isDisabledLimite() && !model.escutaInicial"
                    >
                        Escuta Inicial/Orientação
                    </rkm-form-checkbox>
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-input
                        label="Área/Microárea do domicílio"
                        v-model="model.microarea"
                        disabled
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            v-if="model.turnoId"
            title="Procedimentos/Pequenas cirurgias"
            type="fieldset"
            no-margin-top
        >
            <rkm-row class="flex-nowrap">

                <rkm-col class="flex-grow-1">

                    <rkm-form-checkbox-group
                        v-model="model.procedimentoPequenaCirurgia"
                        name="Procedimentos/Pequenas cirurgias"
                    >
                        <rkm-form-checkbox
                            v-for="procedimento in data.form.procedimentoPequenaCirurgia"
                            :key="procedimento.id"
                            :value="procedimento.id"
                            :disabled="procedimento.isDisabled || isDisabledLimite()
                                && !model.procedimentoPequenaCirurgia.includes(procedimento.id)"
                            class="w-50 m-0"
                        >
                            {{ procedimento.descricao }}
                        </rkm-form-checkbox>
                    </rkm-form-checkbox-group>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            v-if="model.turnoId"
            title="Teste rápido"
            type="fieldset"
            no-margin-top
        >
            <rkm-row class="flex-nowrap">

                <rkm-col class="flex-grow-1">

                    <rkm-form-checkbox-group
                        v-model="model.testeRapido"
                        name="Teste Rápido"
                    >
                        <rkm-form-checkbox
                            v-for="testeRapido in data.form.testeRapido"
                            :key="testeRapido.id"
                            :value="testeRapido.id"
                            :disabled="testeRapido.isDisabled || isDisabledLimite()
                                && !model.testeRapido.includes(testeRapido.id)"
                            class="w-25 m-0"
                        >
                            {{ testeRapido.descricao }}
                        </rkm-form-checkbox>
                    </rkm-form-checkbox-group>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            v-if="model.turnoId"
            title="Administração de medicamentos"
            type="fieldset"
            no-margin-top
        >
            <rkm-row class="flex-nowrap">

                <rkm-col class="flex-grow-1">

                    <rkm-form-checkbox-group
                        v-model="model.administracaoMedicamento"
                        name="Administração de medicamento"
                    >
                        <rkm-form-checkbox
                            v-for="administracaoMedicamento in data.form.administracaoMedicamento"
                            :key="administracaoMedicamento.id"
                            :value="administracaoMedicamento.id"
                            :disabled="administracaoMedicamento.isDisabled || isDisabledLimite()
                                && !model.administracaoMedicamento.includes(administracaoMedicamento.id)"
                            class="w-25 m-0"
                        >
                            {{ administracaoMedicamento.descricao }}
                        </rkm-form-checkbox>
                    </rkm-form-checkbox-group>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            v-if="model.turnoId"
            type="fieldset"
            title="Informações gerais"
        >
            <FormInformacao
                :data="data"
                :model="model"
            />
        </rkm-area>

        <rkm-area
            v-if="model.turnoId"
            title="Procedimento"
            type="fieldset"
            no-margin-top
        >
            <rkm-row>
                <rkm-col class="pb-2 flex-grow-1">
                    <rkm-form-input-autocomplete
                        :repository="repositories.procedimento"
                        :request-query-string-params="autocompletesRequestParams.procedimento.queryString"
                        :search-fields="fields.autocompletes.procedimento"
                        :text-field="p => `${p.codigo} - ${p.nome}`"
                        name="Procedimento"
                        v-model="procedimento"
                        :disabled="isDisabledLimite()"
                    >
                        <rkm-input-group-append slot="append">
                            <rkm-input-group-text>
                                <rkm-form-radio-group v-model="searchByApelido">
                                    <rkm-form-radio :value="false">Código / Nome</rkm-form-radio>
                                    <rkm-form-radio :value="true">Apelido</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-input-group-text>
                        </rkm-input-group-append>
                    </rkm-form-input-autocomplete>
                </rkm-col>

                <rkm-col class="flex-grow-0">
                    <rkm-button
                        :label="false"
                        color="primary"
                        @click="saveProcedimento()"
                        class="mt-0"
                        :disabled="isDisabledLimite()"
                    >
                        Incluir
                    </rkm-button>
                </rkm-col>
            </rkm-row>

            <rkm-table
                :fields="fields.procedimento"
                :items="model.procedimentos"
                hide-filters
                hide-pagination
            >

                <template v-slot:cell(codigo)="row">
                    {{ row.item.codigo | formatProcedimento }}
                </template>

                <template v-slot:cell(actions)="{ index }">

                    <rkm-button
                        @click="destroy(index)"
                        color="danger"
                        small
                        title="Excluir"
                    >
                        <rkm-icon icon="trash" />
                    </rkm-button>
                </template>
            </rkm-table>
        </rkm-area>

        <rkm-area
            v-if="model.paciente && model.paciente.cidadao.idade.anos >= 60"
            title="IVCF - Índice de vulnerabilidade clínico-funcional"
            type="fieldset"
        >
            <rkm-row>
                <rkm-col>
                    <p>
                        As perguntas são direcionadas à pessoa idosa e, quando possível, devem ser confirmadas pelo familiar ou acompanhante, desde
                        que convivam com a pessoa idosa e estejam em condições de responder aos questionamentos. Nas pessoas idosas incapazes de
                        responder, utilizar as respostas do cuidador.
                    </p>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-alert>Em geral o tempo de aplicação deste instrumento varia de 5 a 10 minutos.</rkm-alert>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-radio-group
                        @change="handleDesejaPreencherChange"
                        label="Deseja preencher o IVCF 20 para esta pessoa?"
                        v-model="model.ivcf.desejaPreencher"
                    >
                        <rkm-form-radio :value="true">Sim</rkm-form-radio>
                        <rkm-form-radio :value="false">Nao</rkm-form-radio>
                    </rkm-form-radio-group>
                </rkm-col>
            </rkm-row>

            <template v-if="model.ivcf.desejaPreencher">
                <rkm-row>
                    <rkm-col>
                        <h5>Perguntas do instrumento</h5>
                    </rkm-col>
                </rkm-row>

                <rkm-area title="Idade do cidadão | Grupo 1 de 8">
                    <rkm-form-input
                        :value="`${model.paciente.cidadao.idade.anos} anos e ${model.paciente.cidadao.idade.meses} meses.`"
                        name="pacienteIdade"
                        readonly
                    />
                </rkm-area>

                <rkm-area no-margin-top title="Percepção da saúde | Grupo 2 de 8">
                    <rkm-row>
                        <rkm-col>
                            <rkm-form-radio-group
                                :validations="validations.ivcf.estadoSaudeGeral"
                                label="Em geral, comparando com outras pessoas de sua idade, você diria que sua saúde é"
                                v-model="model.ivcf.estadoSaudeGeral"
                            >
                                <rkm-form-radio value="excelente_muito_boa_ou_boa">Excelente, muito boa ou boa</rkm-form-radio>
                                <rkm-form-radio value="regular_ou_ruim">Regular ou ruim</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>

                <rkm-area no-margin-top title="Atividades de vida diária | Grupo 3 de 8">
                    <rkm-row>
                        <rkm-col>
                            <strong class="text-info">Atividades de vida diária instrumental</strong>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <p>Por causa de sua saúde ou condição física,</p>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-radio-group
                                :validations="validations.ivcf.limitacaoCompras"
                                label="Você deixou de fazer compras?"
                                v-model="model.ivcf.limitacaoCompras"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não ou não faz compras por outros motivos que não a saúde</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-radio-group
                                :validations="validations.ivcf.limitacaoGestaoFinanceira"
                                label="Você deixou de controlar seu dinheiro, gastos ou pagar as contas de sua casa?"
                                v-model="model.ivcf.limitacaoGestaoFinanceira"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não ou não controla o dinheiro por outros motivos que não a saúde</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-radio-group
                                :validations="validations.ivcf.limitacaoTarefasDomesticas"
                                label="Você deixou de realizar pequenos trabalhos domésticos, como lavar a louça, arrumar a casa ou fazer limpeza leve?"
                                v-model="model.ivcf.limitacaoTarefasDomesticas"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não ou não faz mais pequenos trabalhos domésticos por outros motivos que não a saúde</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <strong class="text-info">Atividades de vida diária básica</strong>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-radio-group
                                :validations="validations.ivcf.banhoIndependencia"
                                label="Por causa de sua saúde ou condição física, você deixou de tomar banho sozinho?"
                                v-model="model.ivcf.banhoIndependencia"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>

                <rkm-area no-margin-top title="Cognição | Grupo 4 de 8">
                    <rkm-row>
                        <rkm-col>
                            <rkm-form-radio-group
                                :validations="validations.ivcf.relatoEsquecimentoPorTerceiros"
                                label="Algum familiar ou amigo falou que você está ficando esquecido?"
                                v-model="model.ivcf.relatoEsquecimentoPorTerceiros"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-radio-group
                                :validations="validations.ivcf.esquecimentoPiorando"
                                label="Você tem um esquecimento que está piorando nos últimos meses?"
                                v-model="model.ivcf.esquecimentoPiorando"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-radio-group
                                :validations="validations.ivcf.esquecimentoImpactaAtividades"
                                label="Você tem um esquecimento que está impedindo a realização de alguma atividade do cotidiano?"
                                v-model="model.ivcf.esquecimentoImpactaAtividades"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>

                <rkm-area no-margin-top title="Humor | Grupo 5 de 8">
                    <rkm-row>
                        <rkm-col>
                            <p>No último mês,</p>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-radio-group
                                :validations="validations.ivcf.humorTristezaDesanimo"
                                label="Você ficou com desânimo, tristeza ou desesperança?"
                                v-model="model.ivcf.humorTristezaDesanimo"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-radio-group
                                :validations="validations.ivcf.perdaInteresseAtividades"
                                label="Você perdeu o interesse ou prazer em atividades anteriormente prazerosas?"
                                v-model="model.ivcf.perdaInteresseAtividades"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>

                <rkm-area no-margin-top title="Mobilidade | Grupo 6 de 8">
                    <rkm-row>
                        <rkm-col>
                            <strong class="text-info">Alcance, preensão e pinça</strong>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-radio-group
                                :validations="validations.ivcf.limitacaoElevarBracos"
                                label="Você é incapaz de elevar os braços acima do nível do ombro?"
                                v-model="model.ivcf.limitacaoElevarBracos"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-radio-group
                                :validations="validations.ivcf.limitacaoMotricidadeFina"
                                label="Você é incapaz de manusear ou segurar pequenos objetos?"
                                v-model="model.ivcf.limitacaoMotricidadeFina"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <strong class="text-info">Capacidade aeróbica e/ou muscular</strong>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-radio-group
                                :validations="validations.ivcf.perdaPesoNaoIntencional"
                                label="Você teve perda de peso não intencional de 4,5 kg ou 5% do peso corporal no último ano, 6 kg nos últimos 6 meses ou 3 kg no último mês?"
                                v-model="model.ivcf.perdaPesoNaoIntencional"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-radio-group
                                :validations="validations.ivcf.imcAbaixo22"
                                label="Você tem Índice de Massa Corporal (IMC) menor que 22 kg/m²?"
                                v-model="model.ivcf.imcAbaixo22"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-radio-group
                                :validations="validations.ivcf.panturrilhaAbaixo31"
                                label="Você tem a circunferência (perímetro) da panturrilha menor que 31 centímetros?"
                                v-model="model.ivcf.panturrilhaAbaixo31"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-radio-group
                                :validations="validations.ivcf.marchaLenta4mMaior5s"
                                label="Em um teste de velocidade da marcha, o tempo gasto pela pessoa idosa para percorrer 4 metros é maior do que 5 segundos?"
                                v-model="model.ivcf.marchaLenta4mMaior5s"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <strong class="text-info">Marcha</strong>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-radio-group
                                :validations="validations.ivcf.dificuldadeCaminharImpactoAtividades"
                                label="Você tem dificuldade para caminhar que possa impedir a realização de alguma atividade do cotidiano?"
                                v-model="model.ivcf.dificuldadeCaminharImpactoAtividades"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-radio-group
                                :validations="validations.ivcf.quedasRecorrentes"
                                label="Você teve duas ou mais quedas no último ano?"
                                v-model="model.ivcf.quedasRecorrentes"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <strong class="text-info">Continência esfincteriana</strong>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-radio-group
                                :validations="validations.ivcf.incontinencia"
                                label="Você perde urina ou fezes, sem querer, em algum momento?"
                                v-model="model.ivcf.incontinencia"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>

                <rkm-area no-margin-top title="Comunicação | Grupo 7 de 8">
                    <rkm-row>
                        <rkm-col>
                            <strong class="text-info">Visão</strong>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-radio-group
                                :validations="validations.ivcf.problemaVisaoImpactoAtividades"
                                label="Você tem problemas de visão capazes de impedir a realização de alguma atividade do cotidiano? (É permitido o uso de óculos ou lentes de contato)"
                                v-model="model.ivcf.problemaVisaoImpactoAtividades"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <strong class="text-info">Audição</strong>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-radio-group
                                :validations="validations.ivcf.problemaAudicaoImpactoAtividades"
                                label="Você tem problemas de audição capazes de impedir a realização de alguma atividade do cotidiano? (É permitido o uso de aparelhos de audição)"
                                v-model="model.ivcf.problemaAudicaoImpactoAtividades"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>

                <rkm-area no-margin-top title="Comorbidade múltipla | Grupo 8 de 8">
                    <rkm-row>
                        <rkm-col>
                            <rkm-form-radio-group
                                :validations="validations.ivcf.doencasCronicasMultiplas"
                                label="Você tem cinco ou mais doenças crônicas?"
                                v-model="model.ivcf.doencasCronicasMultiplas"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-radio-group
                                :validations="validations.ivcf.polifarmacia5OuMaisMedicamentos"
                                label="Você faz uso regular de cinco ou mais medicamentos diferentes todos os dias?"
                                v-model="model.ivcf.polifarmacia5OuMaisMedicamentos"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-radio-group
                                :validations="validations.ivcf.internacaoUltimos6Meses"
                                label="Você teve alguma internação nos últimos 6 meses?"
                                v-model="model.ivcf.internacaoUltimos6Meses"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>

                <template v-if="pontuacaoIvcf > 0">
                    <rkm-area no-margin-top title="Pontuação final do IVCF 20">
                        <rkm-alert
                            v-if="pontuacaoIvcf <= 6"
                            color="success"
                        >
                            Idoso com BAIXO risco de vulnerabilidade Clínico-funcional – IDOSO ROBUSTO
                        </rkm-alert>

                        <rkm-alert
                            v-if="pontuacaoIvcf >= 7 && pontuacaoIvcf <= 14"
                            color="warning"
                        >
                            Idoso com MODERADO risco de vulnerabilidade Clínico-funcional – IDOSO EM RISCO DE FRAGILIZAÇÃO
                        </rkm-alert>

                        <rkm-alert
                            v-if="pontuacaoIvcf >= 15"
                            color="danger"
                        >
                            Idoso com ALTO risco de vulnerabilidade Clínico-funcional – IDOSO FRÁGIL
                        </rkm-alert>
                    </rkm-area>
                </template>
            </template>
        </rkm-area>
    </div>
</template>

<script>
// Vuex.
import { mapActions } from 'vuex'

// Utils
import validaCpf from '@/utils/validations/cpf'
import validaCns from '@/utils/validations/cns'

// Moment.
import moment from 'moment'

// Filters.
import format from '@/filters/formats'

//Enums
import tipoAtendimento from '@/enums/atencao-basica/atendimento-individual/tipoAtendimento'
import testeRapido from '@/enums/atencao-basica/procedimento/testeRapido'
import limite from '@/enums/atencao-basica/procedimento/limite'
import pequenaCirurgia from '@/enums/atencao-basica/procedimento/pequenaCirurgia'
import procedimento from '@/enums/sigtap/procedimento'
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'
import sexo from '@/enums/cadastro/cidadao/sexo'
import subclassificacao from '@/enums/cadastro/paciente/subclassificacao'

import FormInformacao from '../informacao/Form.vue'

// Mixins.
import { repository, object, formats, stringCase, data } from '@/mixins'

export default {
    components: {
        FormInformacao
    },
    computed: {
        autocompletesRequestParams() {

            return {
                procedimento: {
                    queryString: {
                        search_by_apelido: this.model.searchByApelido,
                        paciente_id: this.model.cidadao ? this.model.cidadao.pacienteId : null,
                        cbo: this.data.model.cadastro ? this.data.model.cadastro.ocupacaoId : null,
                        competencia: this.competencia,
                        where_not:{
                            'codigo': [
                                this.enums.procedimento.TESTE_RAPIDO_PARA_DETECCAO_DE_INFECCAO_PELO_HBV,
                            ]
                        },
                        ficha_procedimento: true,
                    }
                }
            }
        },
        competencia() {

            if (this.data.model.cadastro && this.data.model.cadastro.dataUsuarioResponsavel) {

                return moment(this.data.model.cadastro.dataUsuarioResponsavel).format('YYYYMM')
            }

            return ''
        },
        fields() {

            return {
                paciente: [
                    { key: 'cidadao.nome', searchable: true },
                ],
                procedimento: [
                    {
                        key: "codigo",
                        label: "Código",
                        class: "col-min",
                    },
                    {
                        key: "nome",
                        label: "Procedimento",
                    },
                    {
                        key: "actions",
                        label: "Ações",
                        class: "col-min",
                    },
                ],
                autocompletes: {
                    procedimento: this.model.searchByApelido
                        ? [{ key: 'parametrizacao_procedimento.apelido', searchable: true }]
                        : [{ key: 'nome', searchable: true }, { key: 'codigo', searchable: true }],
                }
            }
        },
        validations() {

            return {
                paciente: { required: true },
                localAtendimento: { required: true },
                turno: { required: true },
                ivcf: {
                    estadoSaudeGeral: { required: true },
                    limitacaoCompras: { required: true },
                    limitacaoGestaoFinanceira: { required: true },
                    limitacaoTarefasDomesticas: { required: true },
                    banhoIndependencia: { required: true },
                    relatoEsquecimentoPorTerceiros: { required: true },
                    esquecimentoPiorando: { required: true },
                    esquecimentoImpactaAtividades: { required: true },
                    humorTristezaDesanimo: { required: true },
                    perdaInteresseAtividades: { required: true },
                    limitacaoElevarBracos: { required: true },
                    limitacaoMotricidadeFina: { required: true },
                    perdaPesoNaoIntencional: { required: true },
                    imcAbaixo22: { required: true },
                    panturrilhaAbaixo31: { required: true },
                    marchaLenta4mMaior5s: { required: true },
                    dificuldadeCaminharImpactoAtividades: { required: true },
                    quedasRecorrentes: { required: true },
                    incontinencia: { required: true },
                    problemaVisaoImpactoAtividades: { required: true },
                    problemaAudicaoImpactoAtividades: { required: true },
                    doencasCronicasMultiplas: { required: true },
                    polifarmacia5OuMaisMedicamentos: { required: true },
                    internacaoUltimos6Meses: { required: true },
                },
            }
        },
        isDisabled() {
            return this.model.escutaInicial
        },
        pontuacaoIvcf() {
            let pontuacao = 0

            if (this.model.paciente.cidadao.idade.anos >= 75 && this.model.paciente.cidadao.idade.anos <= 84) {
                pontuacao += 1
            }
            else if (this.model.paciente.cidadao.idade.anos >= 85) {
                pontuacao += 3
            }

            if (this.model.ivcf.estadoSaudeGeral === 'regular_ou_ruim') {
                pontuacao += 1
            }

            if (this.model.ivcf.limitacaoCompras || this.model.ivcf.limitacaoGestaoFinanceira || this.model.ivcf.limitacaoTarefasDomesticas) {
                pontuacao += 4
            }

            if (this.model.ivcf.banhoIndependencia) {
                pontuacao += 6
            }

            if (this.model.ivcf.relatoEsquecimentoPorTerceiros) {
                pontuacao += 1
            }

            if (this.model.ivcf.esquecimentoPiorando) {
                pontuacao += 1
            }

            if (this.model.ivcf.esquecimentoImpactaAtividades) {
                pontuacao += 2
            }

            if (this.model.ivcf.humorTristezaDesanimo) {
                pontuacao += 2
            }

            if (this.model.ivcf.perdaInteresseAtividades) {
                pontuacao += 2
            }

            if (this.model.ivcf.limitacaoElevarBracos) {
                pontuacao += 1
            }

            if (this.model.ivcf.limitacaoMotricidadeFina) {
                pontuacao += 1
            }

            if (this.model.ivcf.perdaPesoNaoIntencional || this.model.ivcf.imcAbaixo22 || this.model.ivcf.panturrilhaAbaixo31 || this.model.ivcf.marchaLenta4mMaior5s) {
                pontuacao += 2
            }

            if (this.model.ivcf.dificuldadeCaminharImpactoAtividades) {
                pontuacao += 2
            }

            if (this.model.ivcf.quedasRecorrentes) {
                pontuacao += 2
            }

            if (this.model.ivcf.incontinencia) {
                pontuacao += 2
            }

            if (this.model.ivcf.problemaVisaoImpactoAtividades) {
                pontuacao += 2
            }

            if (this.model.ivcf.problemaAudicaoImpactoAtividades) {
                pontuacao += 2
            }

            if (this.model.ivcf.doencasCronicasMultiplas || this.model.ivcf.polifarmacia5OuMaisMedicamentos || this.model.ivcf.internacaoUltimos6Meses) {
                pontuacao += 4
            }

            return pontuacao
        },
    },
    created() {

        this.repositories = {
            atendimento: this.getConectaSusRepository('atencaoBasica.procedimento'),
            procedimento: this.getConectaSusRepository('sigtap.procedimento'),
            paciente: this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente'),
        }
    },
    data: () => ({
        enums: {
            tipoAtendimento,
            procedimento,
            preferenciaNome,
            sexo,
            testeRapido,
            limite,
            pequenaCirurgia,
            subclassificacao
        },
        procedimento: null,
        searchByApelido: false,
        utils: {
            validaCpf,
            validaCns
        },
    }),
    filters: {
        ...format,
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                if (!valid) return

                if (this.isRequired()) {

                    this.showAlert(`É necessário escolher pelo menos uma opção entre os grupos de Procedimentos/Pequenas
                        Cirurgias, Teste Rápido, Administração de Medicamentos, Procedimentos – SIA e Informações
                        Gerais, ou assinalar como Escuta Inicial/Orientação.`, "Atenção")
                    return false
                }

                const param = this.clone(this.model)
                param.nome = param.paciente.cidadao.nome
                param.nomeSocial = param.paciente.cidadao.nomeSocial
                param.pacienteId = param.paciente.id
                param.turno = this.data.form.turnos.find(turno => turno.id == this.model.turnoId)
                param.localAtendimento = this.data.form.localAtendimento.find(local => local.id == this.model.localAtendimentoId)

                if (this.index !== null) {

                    this.$set(this.model, this.index, this.clone(param))
                } else {

                    this.model.push(this.clone(param))
                }

                this.handleCompetencia()
                this.resetForm()
                this.$refs.RkmModal.hide()
            })
        },
        handleCompetencia() {

            let procedimentos = []

            const procedimentosSelecionados = this.data.form.procedimentoPequenaCirurgia.filter(procedimento => {
                return this.model.procedimentoPequenaCirurgia.includes(procedimento.id)
            })

            procedimentosSelecionados.forEach(cirurgia => {

                const isCompetenciaValid = !!this.data.form.sigtapCompetencias
                    .find(f => f.id === cirurgia.competenciaId)

                if (!isCompetenciaValid) {
                    procedimentos.push(cirurgia.descricao)
                }
            })

            if (procedimentos.length > 0) {

                this.showAlert(`Os seguintes procedimentos foram revogados ou não fazem parte das competências de
                    faturamento permitidas. Portanto, serão registrados, mas não faturados:
                    <strong>${procedimentos.join(', ')}</strong>.`, "Atenção")
            }
        },
        isRequired() {

            return !this.model.escutaInicial
                && !this.model.peso
                && !this.model.altura
                && !this.model.afericao
                && !this.model.glicemia
                && !this.model.temperatura
                && !this.model.exameLaboratorial
                && this.model.procedimentoPequenaCirurgia.length === 0
                && this.model.testeRapido.length === 0
                && this.model.administracaoMedicamento.length === 0
                && this.model.procedimentos.length === 0
        },
        resetForm() {

            this.model.procedimento = null
        },
        handleCancel() {

            this.resetForm()
            this.$refs.RkmModal.hide()
        },
        getCadastroDomiciliar(domicilioId) {

            if (!this.model.microareaId) {

                this.setLoading()

                this.repositories.atendimento.getCadastroDomiciliar({
                    domicilio_id: domicilioId,
                    profissional_equipe_id: this.data.model.cadastro.equipeId
                })
                    .then(({ data }) => {

                        this.model.microarea = data.descricao ?? null
                        this.model.microareaId = data.microareaId ?? null

                        if (data.areaId && !data.pertenceArea) {

                            this.showAlert(`O paciente não está dentro da área de atuação do profissional responsável.`, "Atenção")
                        }
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        isDisabledLimite() {

            if (Object.keys(this.model).length > 0) {
                const limite = this.handleLimite()
                return limite >= this.enums.limite.QUANTIDADE ? true : false
            }

            return false
        },
        handleLimite() {

            const quantidadeEscutaInicial = this.model.escutaInicial ? 1 : 0

            const limite = quantidadeEscutaInicial
                + this.model.procedimentoPequenaCirurgia.length
                + this.model.testeRapido.length
                + this.model.administracaoMedicamento.length
                + this.model.procedimentos.length

            return limite
        },
        saveProcedimento() {

            if (!this.procedimento) {

                this.showAlert('Necessário informar o procedimento.', "Atenção")
                return false
            }

            const procedimento = this.model.procedimentos.find(procedimento => procedimento.id == this.procedimento.id)

            if (procedimento) {

                this.showAlert('O procedimento já foi cadastrado anteriormente na ficha.', "Atenção")
                return false
            }

            const limite = this.handleLimite()

            if (limite >= this.enums.limite.QUANTIDADE) {
                this.showAlert('Foi atingido o limite de 20 procedimentos por ficha.', "Atenção")
                return false
            }

            if (this.procedimento.codigo == this.enums.procedimento.ESCUTA_INICIAL_ORIENTACAO_ACOLHIMENTO_A_DEMANDA_ESPONTANEA) {

                    this.showAlert(`A escuta inicial/orientação deve ser registrada pelo campo próprio da ficha e não pela lista de procedimentos.`, "Atenção")
                    return false
            }

            const param = {
                id: this.procedimento.id,
                nome: this.procedimento.nome,
                codigo: this.procedimento.codigo,
            }

            this.model.procedimentos.push(this.clone(param))

            this.resetProcedimento()
        },
        resetProcedimento() {

            this.procedimento = null
        },
        destroy(index) {

            const destroy = async () => this.model.procedimentos.splice(index, 1)

            this.showDeleteConfirmation('Deseja realmente excluir o procedimento?', destroy)
        },
        resetPaciente() {

            this.model.paciente = null
            this.model.prontuario = null
            this.model.nomeSocial = null
            this.model.prefereNomeSocial = null
            this.model.cns = null
            this.model.cpf = null
            this.model.dataNascimento = null
            this.model.microarea = null
        },
        handleEscutaInicial() {

            if (this.model.escutaInicial) {

                this.showAlert(`Ao marcar a opção de atendimento 'Escuta inicial / Orientação', o procedimento
                    <strong>(0301040079 - ESCUTA INICIAL / ORIENTAÇÃO (ACOLHIMENTO A DEMANDA ESPONTÂNEA)</strong>
                    é incluído automaticamente, dispensando a necessidade de adicionar e listar na caixa de
                    procedimentos.`, "Atenção")
            }
        },
        getProcedimentos() {

            this.setLoading()

            this.repositories.atendimento.getProcedimentos(this.prepareData())
                .then(response => {

                    this.data.form.testeRapido = Object.assign(response.data.testeRapido)
                    this.data.form.administracaoMedicamento = Object.assign(response.data.administracaoMedicamento)
                    this.data.form.procedimentoPequenaCirurgia = Object.assign(response.data.procedimentoPequenaCirurgia)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getCadastroIndividual() {

            this.setLoading()

            this.repositories.atendimento.getCadastroIndividual({paciente_id: this.model.paciente.id})
                .then(response => {

                    if (response.data) {
                        this.showAlert(`A paciente apresenta informações ausentes em seu cadastro individual.
                            Por gentileza, conclua o cadastro para prevenir possíveis falhas na exportação de dados.`,
                            'Atenção'
                        )
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        prepareData() {

            const ocupacaoId = this.clone(this.data.model.cadastro.ocupacaoId)
            const pacienteId = this.clone(this.model.paciente.id)

            return this.camelObjectKeysToSnakeRecursive({
                ocupacaoId, pacienteId
            })
        },
        isDisabledInformacoes(codigo) {

            return this.data.model.procedimentoUsuario
                && this.data.model.procedimentoUsuario.find(procedimento => procedimento.codigo == codigo).isDisabled
        },
        getEquipe() {

            return this.data.form.equipes.find(equipe => equipe.id == this.data.model.cadastro.equipeId) ?
                this.data.form.equipes.find(equipe => equipe.id == this.data.model.cadastro.equipeId).descricao
                : ''
        },
        getOcupacao() {

            return this.data.form.ocupacoes.find(equipe => equipe.id == this.data.model.cadastro.ocupacaoId) ?
                this.data.form.ocupacoes.find(equipe => equipe.id == this.data.model.cadastro.ocupacaoId).codigoNome
                : ''
        },
        handleDesejaPreencherChange(value) {
            if (value === false) {
                this.showConfirmation(
                    'Deseja realmente descartar os dados já preenchidos do IVFC 20?',
                    async () => {
                        this.model.ivcf.estadoSaudeGeral = null
                        this.model.ivcf.limitacaoCompras = null
                        this.model.ivcf.limitacaoGestaoFinanceira = null
                        this.model.ivcf.limitacaoTarefasDomesticas = null
                        this.model.ivcf.banhoIndependencia = null
                        this.model.ivcf.relatoEsquecimentoPorTerceiros = null
                        this.model.ivcf.esquecimentoPiorando = null
                        this.model.ivcf.esquecimentoImpactaAtividades = null
                        this.model.ivcf.humorTristezaDesanimo = null
                        this.model.ivcf.perdaInteresseAtividades = null
                        this.model.ivcf.limitacaoElevarBracos = null
                        this.model.ivcf.limitacaoMotricidadeFina = null
                        this.model.ivcf.perdaPesoNaoIntencional = null
                        this.model.ivcf.imcAbaixo22 = null
                        this.model.ivcf.panturrilhaAbaixo31 = null
                        this.model.ivcf.marchaLenta4mMaior5s = null
                        this.model.ivcf.dificuldadeCaminharImpactoAtividades = null
                        this.model.ivcf.quedasRecorrentes = null
                        this.model.ivcf.incontinencia = null
                        this.model.ivcf.problemaVisaoImpactoAtividades = null
                        this.model.ivcf.problemaAudicaoImpactoAtividades = null
                        this.model.ivcf.doencasCronicasMultiplas = null
                        this.model.ivcf.polifarmacia5OuMaisMedicamentos = null
                        this.model.ivcf.internacaoUltimos6Meses = null
                    },
                    async () => {
                        this.model.ivcf.desejaPreencher = true
                    }
                )
            }
        },
    },
    mixins: [ repository, object, formats, stringCase, data ],
    props: {
        data: { type: Object, required: true },
        model: { type: Object, required: true },
    },
    mounted() {

        const paciente = this.model.paciente

        if (paciente && paciente.id) {

            this.model.prontuario = paciente.prontuario
            this.model.nomeSocial = paciente.cidadao.nomeSocial ?? null
            this.model.prefereNomeSocial = paciente.cidadao.preferenciaNomeId
                === this.enums.preferenciaNome.NOME_SOCIAL ? true : false
            this.model.cns = paciente.cidadao.cns
            this.model.cpf = paciente.cidadao.cpf
            this.model.dataNascimento = paciente.cidadao.dataNascimento

            this.getCadastroDomiciliar(paciente.cidadao.domicilioId)
            this.getProcedimentos()
        }
    },
    watch: {
        'model.paciente': function (paciente) {

            if (paciente) {

                this.setLoading()

                this.repositories.paciente.validCNS(this.camelObjectKeysToSnakeRecursive({pacienteId: paciente.id}))
                    .then(response => {

                        if (!response.data.additionals.cnsValido && response.data.additionals.avisaCnsTemporarioInvalido) {

                            this.showWarningNotification('Paciente com CNS inválido. Registro não permitido.')
                            this.model.paciente = null
                            return false
                        }

                        if (this.model.paciente.subclassificacaoId === this.enums.subclassificacao.TEMPORARIO
                            && response.data.additionals.avisaCnsTemporarioInvalido) {

                                const confirm = async () => {

                                    return false
                                }

                                const cancel = async () => {

                                    this.model.paciente = null
                                    return false
                                }

                                const msg = `Paciente com cadastro temporário. Deseja continuar?`

                                this.showConfirmation(msg, confirm, cancel)

                                return false
                        }
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())

                this.model.prontuario = paciente.prontuario
                this.model.nomeSocial = paciente.cidadao.nomeSocial ?? null
                this.model.prefereNomeSocial = paciente.cidadao.preferenciaNomeId
                    === this.enums.preferenciaNome.NOME_SOCIAL ? true : false
                this.model.cns = paciente.cidadao.cns
                this.model.cpf = paciente.cidadao.cpf
                this.model.dataNascimento = paciente.cidadao.dataNascimento

                this.getCadastroDomiciliar(paciente.cidadao.domicilioId)
                this.getProcedimentos()

                if (!this.utils.validaCpf(paciente.cidadao.cpf) && !this.utils.validaCns(paciente.cidadao.cns)) {

                    this.showAlert(`O CPF e CNS do paciente estão incorretos. Recomenda-se que pelo menos um deles
                        esteja correto para evitar inconsistências na exportação.`, 'Atenção')
                }
            }
        },
        'model.localAtendimentoId': function () {

            this.model.turnoId = null
        },
        'model.turnoId': function (turno) {

            if (turno) {

                const existe = this.data.model.atendimentos
                    .find(p => p.pacienteId == this.model.paciente.id && p.turnoId == turno
                        && p.localAtendimentoId == this.model.localAtendimentoId && p.id != this.model.id)

                if (existe) {

                    this.$nextTick().then(() => this.model.turnoId = null)
                    this.$nextTick().then(() => this.showAlert(`Paciente já possui atendimento nesta ficha com o
                        mesmo local de atendimento e turno.`, 'Atenção'))
                } else {

                    this.setLoading()

                    this.repositories.atendimento.getAtendimentoPaciente({
                        id: this.data.model.id,
                        usuario_id: this.data.model.cadastro.usuario.id,
                        infraestrutura_id: this.data.model.cadastro.infraestruturaId,
                        equipe_id: this.data.model.cadastro.equipeId,
                        ocupacao_id: this.data.model.cadastro.ocupacaoId,
                        data_usuario_responsavel: this.getFormatedDate(this.data.model.cadastro.dataUsuarioResponsavel, 'YYYY-MM-DD'),
                        paciente_id: this.model.paciente.id,
                        local_atendimento_id: this.model.localAtendimentoId,
                        turno_id: this.model.turnoId,
                        atendimento_id: this.model.id,
                    })
                        .then(({ data }) => {

                            if (data.id && data.usuarioId == this.data.model.cadastro.usuario.id) {

                                this.model.turnoId = null

                                this.showAlert(`Paciente já possui atendimento nesta data, com o mesmo profissional,
                                    unidade, local de atendimento e turno.`, 'Atenção')
                            }
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                    }
            }
        },
        'model.procedimentoPequenaCirurgia': function () {

            if (this.model.procedimentoPequenaCirurgia.includes(this.enums.pequenaCirurgia.COLETA_DE_CITOPATOLOGICO_DE_COLO_UTERINO)) {
                this.getCadastroIndividual()
            }
        },
    }
}
</script>

<style scoped>
.warning {
    color: var(--warning);
}
</style>